/**
 * The backend returns only the opaque token; the absolute URL is composed here so it is
 * always correct for whichever origin the app is actually served from.
 */
export function buildPublicShareUrl(
  publicToken: string,
  origin: string = typeof window !== 'undefined' ? window.location.origin : '',
): string {
  return `${origin}/share/q/${publicToken}`;
}
